import { Component, OnInit, NgZone } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import * as moment from 'moment/moment';
import { ReservationsService } from '@app/shared/services/reservations.service';
import { ClotureService } from '@app/shared/services/cloture.service';
import { ExcelService } from '@app/shared/services/excel.service';
import { SessionService } from '@app/shared/services/session.service';
import { DateService } from '@app/shared/services/date.service';
import { UsersService } from '@app/shared/services/users.service';
import { ActivatedRoute } from '@angular/router';
import { VehiclesService } from '@app/shared/services/vehicles.service';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from "rxjs/internal/operators";
declare var UIkit: any;

@Component({
    selector: 'app-carsharing',
    templateUrl: './carsharing.component.html',
    styleUrls: ['./carsharing.component.scss']
})
export class CarSharingComponent implements OnInit {
    public clotures: Array<any> = [];
    public cloturesAll: Array<any> = [];
    public bookings: Array<any> = [];

    public dateStart: string = moment().hour(0).minute(0).format('yyyy-MM-DDTHH:mm');
    public dateEnd: string = moment().hour(23).minute(59).format('yyyy-MM-DDTHH:mm');
    public dateStartChanged: Subject<string> = new Subject<string>();
    public dateEndChanged: Subject<string> = new Subject<string>();

    public search: string = '';
    public searchChanged: Subject<string> = new Subject<string>();

    public loadingVehicule: boolean = false;
    public loadingStatus: boolean = true;
    public actualReservation: any = {};
    public vehicleSet: boolean = false;
    public vehicleSearch: string = '';
    public vehicleSelected: number = 0;
    public options: any = [];
    public vehicle: any = {};
    public vehicleDisplay: boolean = false
    public _timeout: any = null;
    public noResultVehicule: boolean = false;

    constructor(
        private titleService: TitleService,
        private menu: MenuService,
        private reservationService: ReservationsService,
        private clotureService: ClotureService,
        private excelService: ExcelService,
        private route: ActivatedRoute,
        public session: SessionService,
        private dateService: DateService,
        private userService: UsersService,
        private vehicleService: VehiclesService,
        private router: Router,
        private lc: NgZone
    ) {
        this.searchChanged
            .pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe(model => {
                this.search = model;

                if (this.search !== "") {
                    this.clotures = this.cloturesAll.filter(cloture => cloture.BookingCode.toLowerCase().includes(this.search.toLowerCase()) || cloture.LicensePlate.toLowerCase().includes(this.search.toLowerCase()) || cloture.LicensePlate.toLowerCase().includes(this.search.toLowerCase()))
                } else {
                    this.clotures = this.cloturesAll
                }

            });

        this.dateStartChanged
            .subscribe(model => {
                this.dateStart = model;
                sessionStorage.setItem('clotureFilterDateStart', model);
                this.loadingStatus = true;
                this.getInfo();
            });

        this.dateEndChanged
            .subscribe(model => {
                this.dateEnd = model;
                sessionStorage.setItem('clotureFilterDateEnd', model);
                this.loadingStatus = true;
                this.getInfo();
            });
    }

    ngOnInit() {
        this.route.queryParams
            .subscribe(params => {
                if (params.vehicule) {
                    this.search = params.vehicule;
                    sessionStorage.setItem('clotureFilterSearch', params.vehicule);
                }
            });

        this.getInfo()
        this.titleService.setTitle(`Carsharing / VOP`);
        this.menu.setMenuState('reservation', 'reservation', '');
    }

    setVehicleSearch(option) {
        this.vehicle = option;
        this.vehicleSet = true;
        this.vehicleSearch = option.name;
        this.getInfo();
    }

    toggleSuggestions(shouldDisplay) {
        setTimeout(() => {
            this.vehicleDisplay = shouldDisplay;
        }, 250);
    }

    updateVehicleOptionList(event) {
        if (this._timeout) {
            window.clearTimeout(this._timeout);
        }
        this._timeout = window.setTimeout(() => {
            this._timeout = null;
            this.lc.run(() => {
                this.vehicleSearch = event;
                this.loadingVehicule = true;
                this.noResultVehicule = false;
                this.vehicleService.updateVehicles(1, this.vehicleSearch).then((res) => {
                    if (res.length > 0) {
                        res.forEach((vehicle) => {
                            this.options.push(vehicle);
                        });
                        this.noResultVehicule = (this.options.length > 0) ? false : true;
                    } else {
                        this.noResultVehicule = true;
                    }
                    this.loadingVehicule = false;
                });
            });
        }, 1000);
    }

    async displayModal(reservation): Promise<void> {
        let res = JSON.parse(JSON.stringify(reservation))

        res.Start = moment(reservation.Start, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DDTHH:mm')
        res.End = moment(reservation.End, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DDTHH:mm')

        this.actualReservation = res;
        UIkit.modal('#cloture-car').show();
    }

    async getInfo(): Promise<void> {
        // const res = await fetch("http://localhost:3000/booking").then(res => res.json()); //= await this.clotureService.selectBookingPeriods("", "", "") 

        const res = await this.clotureService.selectBookingPeriods(this.dateStart, this.dateEnd, this.vehicle?.idEquipment)

        for (let i = 0; i < res.length; i++) {
            res[i].ISORealEstimatedEndDate = moment(res[i].ISORealEstimatedEndDate).format('YYYY-MM-DDTHH:mm')
            res[i].ISORealEstimatedStartDate = moment(res[i].ISORealEstimatedStartDate).format('YYYY-MM-DDTHH:mm')
            res[i].IsoRealEndDate = moment(res[i].IsoRealEndDate).format('YYYY-MM-DDTHH:mm')
            res[i].IsoRealStartDate = moment(res[i].IsoRealStartDate).format('YYYY-MM-DDTHH:mm')
            //convert this "07/06/2022 15:25:00" to "2020-06-07T15:25:00"
            // res[i].Start = moment(res[i].Start, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DDTHH:mm')
            // res[i].End = moment(res[i].End, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DDTHH:mm')

            res[i].AlertOlds = res[i].AlertOlds.filter(alert => alert.AlertOldName)
        }

        this.cloturesAll = res
        console.log("this.cloturesAll", this.cloturesAll)

        if (this.search !== "") {
            this.clotures = res.filter(cloture => cloture.BookingCode.toLowerCase().includes(this.search.toLowerCase()) || cloture.LicensePlate.toLowerCase().includes(this.search.toLowerCase()) || cloture.LicensePlate.toLowerCase().includes(this.search.toLowerCase()))
        } else {
            this.clotures = res
        }

        this.loadingStatus = false;
    }

    onSearchChange(search): void {
        this.searchChanged.next(search);
    }

    onDateChange(start, date): void {
        if (start === true) {
            this.dateStartChanged.next(date);
        } else {
            this.dateEndChanged.next(date);
        }
    }

    getData(i, bookingCode): void {
        console.log("L'object en question", i)
        console.log("Le bookingCode en question", bookingCode)

        this.clotures[i].dateReel = bookingCode
    }

    async clotureAdminReservation(): Promise<void> {
        const res = await this.clotureService.clotureReservationAdmin(this.dateStart, this.dateEnd)
        console.log(res)
    }

    saveModification(i): void {
        console.log("L'object en question", i)

        this.clotures[i].dateReel = null
    }

    actualiser(i, bookingCode): void {
        console.log('actualiser ' + bookingCode)
    }

    goToReservations(): void {
        this.router.navigate(['reservation/list']);
    }
}